import React from "react";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../../utils/funcionalidadesStrings";
import {
  Modal,
  ModalClose,
  ModalDialog,
  DialogTitle,
  ModalOverflow,
  Button,
} from "@mui/joy";
import dayjs from "dayjs";
import useComprobanteTurno from "./useComprobanteTurno";
import "./VistaWeb.css";
import { IonIcon } from "@ionic/react";
import { cloudDownload, cloudDownloadOutline } from "ionicons/icons";
import fileDownload from "js-file-download";


const ComprobanteTurno = ({
  turno,
  abrir,
  togleAbrirCerrarComprobanteTurno,
  paciente,
}) => {
  const {
    componentRef,
    pdfBlobUrl,
    heightIframe,
    widthIframe,
    namePdf,
    rendedMobile,
    handleClose,
  } = useComprobanteTurno({ abrir, turno, togleAbrirCerrarComprobanteTurno });


  const RenderComprobante = () => {
    return React.cloneElement(
      <div className="book">
        <div id="comprobante-page" className="page">
          <div className="row">
            <div className="column">
              <img src="assets/icon/logo-consultorio.png" alt="Logo de la clinica" />
            </div>
            {/* <div className="column">
              <p>{servicio.nombre}</p>
              <p>{servicio.direccion}</p>
              <p>{servicio.telefono}</p>
            </div> */}
          </div>
          <p>
            {`Turno para el dia ${obtenerNombreDia(
              dayjs(turno.fecha).format("dddd")
            )} ${dayjs(turno.fecha).format("DD")} de ${dayjs(
              turno.fecha
            ).format("MMMM, YYYY")} a las ${dayjs(turno.hora).format("HH:mm")}`}
          </p>
          <p>
            <strong>Profesional:</strong>
            {` ${turno.prestadorNom}`}
          </p>
          <p>
            <strong>Lugar de atencion:</strong>
            {` ${turno.lugarAtencion}`}
          </p>
          <p>
            <strong>Paciente:</strong>
            {` ${turno.documentoNro} - ${turno.apellido}, ${turno.nombre}`}
          </p>

          <p>
            <strong>Mutual:</strong>
            {` ${turno.mutualNom} ${
              turno.mutualAfiliado === "-" ? "" : " - " + turno.mutualAfiliado
            }`}
          </p>
          {turno.estudioNom !== null && (
            <>
              <p>
                <strong>Estudio:</strong>
                {` ${turno.estudioNom}`}
              </p>

              {turno.preparacionEstudio !== null && (
                <p>
                  <strong>Preparacion:</strong>
                  {` ${convertToPlain(turno.preparacionEstudio)}`}
                </p>
              )}
            </>
          )}

          <div
            style={{
              borderTop:
                "1px solid var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))",
            }}
          >
            <p>
              {`Impresion via web del dia ${obtenerNombreDia(
                dayjs().format("dddd")
              )} ${dayjs().format("DD")} de ${dayjs().format(
                "MMMM, YYYY"
              )} a las ${dayjs().format("HH:mm")}`}
            </p>
            <p>
              <strong>Codigo de tramite:</strong>
              {` ${turno.codigo}`}
            </p>
            <div>
              <p>
                De no poder asistir, le solicitamos tenga a bien anular el turno
                por lo menos 24 horas
              </p>
              <p>
                antes, pudiendo asi darle el lugar a otra persona que pueda
                necesitarlo.
              </p>
            </div>
          </div>
        </div>
      </div>,
      { ref: componentRef }
    );
  };


  const handleClickDownloadComprobante = async () => {
    const elementToCapture = componentRef.current;
    if (!elementToCapture) {
      console.error("No se encontró el elemento para capturar.");
      return;
    }
    if (!rendedMobile) {
      console.error(
        "Solo se permite descargar por este medio desde dispositivos móviles."
      );
      return;
    }
    try {
      elementToCapture.style.width = `21cm`;
      elementToCapture.style.minHeight = `29.7cm`;
      elementToCapture.style.padding = "2cm";
      elementToCapture.style.margin = "1cm auto";
      elementToCapture.style.border = "1px #d3d3d3 solid";
      elementToCapture.style.borderRadius = "5px";
      elementToCapture.style.background = "white";
      const originalWidth = elementToCapture.scrollWidth;
      const originalHeight = elementToCapture.scrollHeight;
      const scaleFactor = 1.5;
      const scaledWidth = originalWidth * scaleFactor;
      const scaledHeight = originalHeight * scaleFactor;
      const html2canvas = (await import("html2canvas")).default;
      const jsPDF = (await import("jspdf")).default;
      const canvas = await html2canvas(elementToCapture, {
        width: originalWidth,
        height: originalHeight,
      });
      canvas.toBlob((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const pdf = new jsPDF();
        pdf.addImage(blobUrl, "PNG", 20, 10, scaledWidth / 7, scaledHeight / 7);
        if (pdfBlobUrl) {
          fileDownload(
            pdf.output("blob"),
            `Comprobante-Turno-${turno?.codigo}.pdf`
          );
        }
      }, "image/png");
    } catch (e) {
      console.log("No se pudo descargar el comprobante");
    }
    elementToCapture.style.width = "auto";
    elementToCapture.style.minHeight = "auto";
    elementToCapture.style.padding = "0";
    elementToCapture.style.margin = "0";
    elementToCapture.style.border = "none";
    elementToCapture.style.borderRadius = "0";
    elementToCapture.style.background = "none";
  };

  return (
    <Modal open={abrir} onClose={handleClose}>
      <ModalOverflow>
        <ModalDialog
          className="ion-padding"
          style={{
            backgroundColor: "#FFFFFF",
            width: pdfBlobUrl ? `${widthIframe}px` : "auto",
          }}
        >
          {rendedMobile ? (
            <Button
              variant="plain"
              startDecorator={
                <IonIcon
                  md={cloudDownload}
                  ios={cloudDownloadOutline}
                  size="medium"
                />
              }
              onClick={handleClickDownloadComprobante}
            >
              COMPROBANTE DE TURNO
            </Button>
          ) : (
            <DialogTitle>COMPROBANTE DE TURNO</DialogTitle>
          )}
          <ModalClose />
          {((!pdfBlobUrl && !rendedMobile) || rendedMobile) && RenderComprobante()}
          {pdfBlobUrl && !rendedMobile && (
            <iframe
              title={namePdf}
              height={heightIframe}
              src={pdfBlobUrl}
              download={namePdf}
            ></iframe>
          )}
        </ModalDialog>
      </ModalOverflow>
    </Modal>
  );
};

export default ComprobanteTurno;
